/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, Button, IconButton, Tooltip, LinearProgress, CircularProgress, Switch, Chip, Typography, TextField, Collapse } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { colors, fonts } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
import { setAllPostResources, setPostCatList } from '../../../redux/slices/posts/posts';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLocation } from 'react-router-dom';
import CheckboxTree from '../../../components/treeCheckbox/TreeCheckbox,js';
import Box from '@mui/material/Box';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';

const styles = {
	categ: {
		margin: '3rem 0em 0em 3rem',
		border: "1px solid lightgrey",
		padding: "3rem"
	},
};

const PostResources = () => {
	// const {
	//     businessUnits: businessUnitsList,
	//     departments,
	//     subDepartments,
	// } = useSelector((state) => state.lookup);
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { postResources } = useSelector((state) => state?.posts);

	const location = useLocation();
	const [postStatus, setPostStatus] = useState('');
	const [formData, setFormData] = useState({
		name: '',
	});
	const [openDeleteModal, setOpenDeleteModal] = useState(false);

	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [filters, setFilters] = useState({
		search: '',
		status: '',
		date_from: null,
		date_to: null,
	});
	const [filtersOpen, setFiltersOpen] = useState(false);

	const handleFilterChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFilterDateChange = (name, value) => {
		setFilters((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleApplyFilters = () => {
		getResources(currentParams.limit, 1, filters);
	};

	const handleClearFilters = () => {
		const clearedFilters = {
			search: '',
			status: '',
			date_from: null,
			date_to: null,
		};
		setFilters(clearedFilters);
		getResources(currentParams.limit, 1, clearedFilters);
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};
	let sendId = location.pathname === "/corporate-governance-library/legal-and-regulatory/resources" ? 1 : 2;

	const handleSubmit = async () => {
		setIsLoadingModal(true)
		const data = {
			...formData,
			category_nav_id: sendId
		};
		if (isEditing) {

			try {

				if (formData.name) {
					await Api.post(endPoints?.posts?.updateResource, data, {
						headers: {
							'xt-user-token': null
						}
					})
						.then((response) => {
							successNotify("Resource Updated Successfully");
							handleCloseModal();
							getResources();
							setIsLoadingModal(false);
						})
						.catch((error) => {
							// if (error?.response?.status === 400) {
							// 	errorNotify(error?.response?.data);
							// 	setDisabledBtn(false);
							// }
							// setErrMsg(error?.response?.data?.message || errorMsg);
						});

				} else {
					errorNotify('Please Fill All Fields');

				}
			} catch (err) {
				// setErrMsg('Login Failed');
				// setDisabledBtn(false);
			}

		} else {

			try {

				if (formData.name) {
					await Api.post(endPoints?.posts?.createResource, data, {
						headers: {
							'xt-user-token': null
						}
					})
						.then((response) => {
							successNotify("Resource Added Successfully");
							handleCloseModal();
							getResources();
							setIsLoadingModal(false)
						})
						.catch((error) => {
							// if (error?.response?.status === 400) {
							// 	errorNotify(error?.response?.data);
							// 	setDisabledBtn(false);
							// }
							// setErrMsg(error?.response?.data?.message || errorMsg);
						});

				} else {
					errorNotify('Please Fill All Fields');

				}
			} catch (err) {
				// setErrMsg('Login Failed');
				// setDisabledBtn(false);
			}
		}

	};


	const getResources = async (limit, page, filterParams = filters) => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.posts?.getResources, {

				"resource_nav_id": sendId,
				"limit": limit || 10,
				"page": page || 1,
				"search": filterParams.search || null,
				"status": filterParams.status || null,
				"date_from": filterParams.date_from ? dayjs(filterParams.date_from).format('YYYY-MM-DD') : null,
				"date_to": filterParams.date_to ? dayjs(filterParams.date_to).format('YYYY-MM-DD') : null,

			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllPostResources(
							response?.data?.data?.resources?.resources?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								name: d?.name,
								// description: d?.description,
								category_nav_id: d?.category_nav_id,
								dt: d?.dt,
								is_enabled: d?.is_enabled,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.resources?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false);
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};

	useEffect(() => {
		getResources();
	}, [location])

	const handleEditModal = (val) => {
		setOpenModal(val);
		setFormData({ name: val.name, id: val.id });
		setIsEditing(true);
	};

	const handleDelete = async () => {

	};
	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};

	const handleChangeTableSwitch = async (event, val) => {

		try {

			await Api.post(endPoints?.posts?.deleteResource, {
				id: val.id,
				status: event.target.checked,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					handleCloseDeleteModal();
					successNotify("Resource Status Updated Successfully");
					getResources();

				})
				.catch((error) => {

				});

		} catch (err) {
		}
	};

	const column = [
		{
			title: '#',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Name',
			field: 'name',
			width: "10%",
			render: (rowData) => <h4 className='font-face-B'>{rowData?.name}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		// {
		// 	title: 'delete',
		// 	field: 'delete',
		// 	filtering: false,
		// 	render: (rowData) => (
		// 		<Tooltip title='Delete'>
		// 			<IconButton onClick={() => handleOpenDeleteModal(rowData)} aria-label='Delete'>
		// 				<DeleteIcon />
		// 			</IconButton>
		// 		</Tooltip>
		// 	),
		// },
		{
			title: 'Status',
			field: 'is_enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		},


	];


	const handleCloseModal = () => {
		setOpenModal(false);
		setFormData({ name: '' });
		setIsEditing(false);

	};

	const handleOpenDeleteModal = (val) => {
		setFormData({ id: val.id });
		setOpenDeleteModal(true);
	};
	const handleCloseDeleteModal = () => {
		setFormData({ name: '' });
		setOpenDeleteModal(false);
	};



	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>
				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom btnTitle='Add Resource' onClickHandler={() => setOpenModal(true)} />
				</Flex>

				{/* Filters Section */}
				<Box sx={{ mb: 3, backgroundColor: '#f5f5f5', borderRadius: '8px', overflow: 'hidden' }}>
					{/* Filter Header - Clickable */}
					<Box
						sx={{
							p: 2,
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							'&:hover': { backgroundColor: '#ebebeb' },
							transition: 'background-color 0.2s ease'
						}}
						onClick={() => setFiltersOpen(!filtersOpen)}
					>
						<Flex ai='center' gap='0.5rem'>
							<FilterListIcon sx={{ color: '#666' }} />
							<Typography variant='h6' sx={{ fontSize: '1.6rem', fontWeight: 600, color: '#333' }}>
								Filter Resources
							</Typography>
						</Flex>
						{filtersOpen ? <ExpandLessIcon sx={{ color: '#666' }} /> : <ExpandMoreIcon sx={{ color: '#666' }} />}
					</Box>

					<Collapse in={filtersOpen} timeout={300}>
						<Box sx={{ p: 2, pt: 1 }}>
							{/* Clear All Button */}
							<Flex jc='flex-end' mb='1rem'>
								<Button
									variant='text'
									startIcon={<ClearIcon />}
									onClick={handleClearFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', color: '#666' }}>
									Clear All
								</Button>
							</Flex>

							{/* Search Bar */}
							<Box sx={{ mb: 2 }}>
								<InputControl
									state={filters.search}
									onChange={handleFilterChange}
									label='Search by Name'
									name='search'
								/>
							</Box>

							{/* Dropdown Filters */}
							<Grid gtc='repeat(auto-fit, minmax(18rem, 1fr))' gap='1.5rem'>
								<FilledSelectOption
									label='Status'
									state={filters.status}
									onChange={handleFilterChange}
									options={[
										{ id: 'true', description: 'Active' },
										{ id: 'false', description: 'Inactive' },
									]}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='status'
								/>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date From'
										value={filters.date_from}
										onChange={(value) => handleFilterDateChange('date_from', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date To'
										value={filters.date_to}
										onChange={(value) => handleFilterDateChange('date_to', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
							</Grid>

							<Flex jc='flex-end' gap='1rem' mt='1.5rem'>
								<Button
									variant='contained'
									color='success'
									startIcon={<SearchIcon />}
									onClick={handleApplyFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', px: 3 }}>
									Apply Filters
								</Button>
							</Flex>
						</Box>
					</Collapse>
				</Box>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Update Resource" : 'Create Resource'}
						isLoading={isLoadingModal}
					// submitHandler={leaveApprovedHandler}
					// submitDisabledBtn={leaveApprovedDis}
					>

						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' margin='2.5rem 0' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.name}
									onChange={handleChange}
									// inputProps={{ maxLength: 30 }}
									label='Name'
									name='name'
									required
								/>
							</MarginHandler>


							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.name}
									className='font-face-R'>
									{isEditing ? "Update " : "Create "} Resource
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>


					{/* <DeleteModal
						open={openDeleteModal}
						handleClose={handleCloseDeleteModal}
						handleDelete={handleDelete}
					/> */}
				</Flex>

				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={postResources?.map((item) => ({ ...item }))}
						sorting
						// search
						// filtering
						columnsButton
						showTitle
						paginationType='normal'
						titleHeading='All Resources'
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getResources(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getResources(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}
			</Card>
		</>
	);
};

export default PostResources;
